export default {
    accesos: [
        { route: 'dashboard', modulo: '' },
        { route: '', modulo: 'DashboardVentas' },
        { route: '', modulo: 'DashboardRentabilidadNeta' },
        { route: '', modulo: 'DashboardHistorico' },
        { route: '', modulo: 'DashboardCuentas' },
        { route: '', modulo: 'DashboardAdministracion' },
        { route: '', modulo: 'DashboardProduccion' },

        { route: 'ventas', modulo: '' },
        { route: 'ventas/presupuestosinternos', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id', modulo: '' },
        { route: 'ventas/presupuestosinternos/:id/produccion', modulo: '' },
        { route: 'ventas/presupuestosinternos/ordenestrabajo/:id/produccion', modulo: '' },
        { route: 'ventas/subtrabajos', modulo: '' },
        
        { route: 'logistica', modulo: '' },
        { route: 'logistica/remitos', modulo: '' },
        { route: 'logistica/remitos/add', modulo: '' },
        { route: 'logistica/remitos/:id/duplicado', modulo: '' },
        { route: 'logistica/remitos/:id', modulo: '' },
        { route: 'logistica/destinos', modulo: '' },
        { route: 'logistica/destinos/:id', modulo: '' },
        { route: 'logistica/destinos/:id/ABM', modulo: '' },
        { route: 'logistica/actualizacion-importes', modulo: '' },

        { route: 'proveedores', modulo: '' },
        { route: 'proveedores/proveedores', modulo: '' },
        { route: 'proveedores/proveedores/add', modulo: '' },
        { route: 'proveedores/proveedores/:id/edit', modulo: '' },
        { route: 'proveedores/proveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id/ABM', modulo: '' },
        { route: 'proveedores/ordenesproveedores/orden-interna', modulo: '' },
        { route: '', modulo: 'OrdenesProveedoresAgregarEvaluacion' },
        { route: 'proveedores/cuentacorrienteproveedores', modulo: '' },
        { route: 'proveedores/evaluaciones-proveedores', modulo: '' },
        { route: 'proveedores/evaluaciones-proveedores/:id', modulo: '' },
    
        { route: 'rrhh', modulo: '' },
        { route: 'rrhh/viaticos', modulo: '' },
        { route: 'rrhh/viaticos/add', modulo: '' },
        { route: 'rrhh/viaticos/:id', modulo: '' },
        { route: 'rrhh/viaticos/:id/edit', modulo: '' },
        { route: 'rrhh/encuestas', modulo: '' },
        { route: 'rrhh/encuestas/:id', modulo: '' },
        { route: 'rrhh/encuestas/:id/completar', modulo: '' },

        { route: 'tablas', modulo: '' },
        { route: 'tablas/articulos', modulo: '' },
        { route: 'tablas/articulos/:id', modulo: '' },
        { route: 'tablas/articulos/:id/ABM', modulo: '' },
        { route: 'tablas/articulosrubros', modulo: '' },
        { route: 'tablas/articulosrubros/:id', modulo: '' },
        { route: 'tablas/articulosrubros/:id/ABM', modulo: '' },
        { route: 'tablas/articulostipos', modulo: '' },
        { route: 'tablas/articulostipos/:id', modulo: '' },
        { route: 'tablas/articulostipos/:id/ABM', modulo: '' },
        { route: 'tablas/localidades', modulo: '' },
    ]
}
